import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";
import type { SingleProduct } from "src/types/graphql.d";

type NotificationChannel = "email" | "push";

type BackInStockNotificationRequestedProps = {
  product: SingleProduct;
  variationId: string;
  email: string;
};

type BackInStockNotificationRequestedAnalyticsProps = {
  product_id: string;
  sku: string;
  name: string;
  brand: string;
  price: number;
  regular_price: number;
  product_size?: string | null;
  image_url?: string | null;
  currency: string;
  channels: NotificationChannel[];
  email: string;
  shop_type?: string;
};

export type BackInStockNotificationRequestedEvent = TrackingEvent<
  "Back In Stock Notification Requested",
  BackInStockNotificationRequestedAnalyticsProps
>;

export async function trackBackInStockNotificationRequestedEvent({
  product,
  variationId,
  email,
}: BackInStockNotificationRequestedProps): TrackingEventResponse {
  const variation = product.variations?.find(({ id }) => id === variationId);

  return await trackEvent("Back In Stock Notification Requested", {
    props: {
      product_id: product.id,
      sku: variationId,
      name: product.name,
      brand: product.brand.name,
      price: product.price,
      regular_price: product.regular_price,
      product_size: variation?.size,
      image_url: product.images?.[0],
      currency: product.currency.code,
      channels: ["email"],
      email,
    },
    withRequestSource: true,
  });
}
